import {MatPaginatorIntl} from '@angular/material/paginator';
import {TranslateService} from '@ngx-translate/core';
import {DecimalPipe} from "@angular/common";
import {inject} from "@angular/core";
import {combineLatest, take} from "rxjs";

export class MatPaginatorIntlTranslate extends MatPaginatorIntl {
    private readonly translate: TranslateService = inject(TranslateService);
    private readonly decimalPipe: DecimalPipe = inject(DecimalPipe);

    constructor() {
        super();
        const labels = ['paginator.itemsPerPage', 'paginator.nextPage', 'paginator.previousPage', 'paginator.firstPage', 'paginator.lastPage'];
        const requests = labels.map(label => this.translate.get(label).pipe(take(1)));

        combineLatest(requests).subscribe(([itemsPerPageLabel, nextPageLabel, previousPageLabel, firstPageLabel, lastPageLabel]) => {
            this.itemsPerPageLabel = itemsPerPageLabel;
            this.nextPageLabel = nextPageLabel;
            this.previousPageLabel = previousPageLabel;
            this.firstPageLabel = firstPageLabel;
            this.lastPageLabel = lastPageLabel;
        });
    }

    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        const ofTranslation = this.translate.instant('paginator.of');

        if (length === 0 || pageSize === 0) {
            return `0 ${ofTranslation} ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} ${ofTranslation} ${this.decimalPipe.transform(length)}`;
    }
}
